export interface LLMResponse {
    data: string | object;
    validJsonSchema: boolean;
    tokenConsumed: number;
}

export interface Part {
    text: string | object;
}

export interface Conversation {
    role: 'user' | 'model';
    parts: Part[];
}

export interface ConversationString {
    role: 'user' | 'model';
    parts: Part[];
}

export enum AgentType {
    VIDEO_CONTENT_GENERATOR_AGENT = "VIDEO_CONTENT_GENERATOR_AGENT",
    VIDEO_TITLE_DESCRIPTION_GENERATOR_AGENT = "VIDEO_TITLE_DESCRIPTION_GENERATOR_AGENT",
    PROPERTY_SELL_AGENT = "PROPERTY_SELL_AGENT"
}

export const getAgentType = (agentType: string): AgentType => {
    switch (agentType) {
        case "VIDEO_CONTENT_GENERATOR_AGENT":
            return AgentType.VIDEO_CONTENT_GENERATOR_AGENT;
        case "VIDEO_TITLE_DESCRIPTION_GENERATOR_AGENT":
            return AgentType.VIDEO_TITLE_DESCRIPTION_GENERATOR_AGENT;
        case "PROPERTY_SELL_AGENT":
            return AgentType.PROPERTY_SELL_AGENT;
        default:
            throw new Error("Invalid agent type");
    }
}

export interface LLMRequest {
    agentType: AgentType;
    message: string;
    conversationHistory?: Conversation[];
}